<template>
  <div class="zadi-session-publisher">
    <volunteers-selector v-if="isReady" v-can="permissions.edit" :data-source-api="dataSourceApi"
      :group-options="groupOptions" :btn-label="btnLabel" @onSubmit="onConfirmPublish" />
  </div>
</template>

<script>
import { RepositoryFactory } from "../../volunteer-repositories/volunteerRepositoryFactory";
import VolunteersSelector from "@/app/volunteer/components/VolunteersSelector.vue";

const zadiSessionsRepo = RepositoryFactory.get("zadiSessionsRepository");

export default {
  name: "ZadiSessionPublisher",
  components: {
    VolunteersSelector,
  },
  data() {
    return {
      permissions: {
        edit: "training_courses_management",
      },
      session: null,
      isReady: false,
      unassignedGroups: [],
      isUnassignedGroupsLoaded: false,
    };
  },
  computed: {
    // الجلسة المنشورة يُعاد نشرها لإضافة متطوعين جدد فقط، لذلك نعرض غير المضافين إليها
    isAddingMore() {
      return !!this.session && this.session.status !== "pending";
    },
    dataSourceApi() {
      return this.isAddingMore ? this.getUnassignedVolunteers : null;
    },
    groupOptions() {
      return this.isAddingMore ? this.unassignedGroups : null;
    },
    btnLabel() {
      return this.isAddingMore ? "إضافة المتطوعين" : "نشر الجلسة";
    },
  },
  methods: {
    async getSession() {
      this.session = await zadiSessionsRepo.getZadiSession(this.$route.params.id);
      this.isReady = true;
    },
    async getUnassignedVolunteers(query) {
      const response = await zadiSessionsRepo.fetchZadiSessionAudience(
        this.$route.params.id,
        `${query}&scope=unassigned`
      );
      // نثبّت قائمة المجموعات على أول جلب، وإلا اختفت بقية الخيارات عند الفلترة بمجموعة
      if (!this.isUnassignedGroupsLoaded) {
        this.unassignedGroups = response.groups || [];
        this.isUnassignedGroupsLoaded = true;
      }
      return response.volunteers || { data: [], total: 0 };
    },
    onConfirmPublish(payload) {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: this.isAddingMore ? "تأكيد إضافة المتطوعين" : "تأكيد نشر الجلسة",
        text: this.isAddingMore
          ? "سيتم إشعار المتطوعين المضافين حديثاً فقط، ولن يتأثر من هم على الجلسة."
          : "سيتم إشعار المتطوعين المحددين وفتح باب التسجيل. لا يمكن التراجع عن النشر.",
        acceptText: this.isAddingMore ? "إضافة" : "نشر",
        cancelText: "إلغاء",
        accept: () => this.publishSession(payload),
      });
    },
    async publishSession(payload) {
      await zadiSessionsRepo.publishZadiSession({
        sessionId: this.$route.params.id,
        payload: { excludedVolunteerIds: payload.excludedVolunteer },
        query: payload.query,
      });
      this.$router.push({ path: "/volunteers/zadi-sessions" });
    },
  },
  created() {
    this.getSession();
  },
};
</script>
